import React, { useEffect, useRef, useState } from "react";
import { CASINO_VIDEO_URL, DEFAULT_BET_AMOUNT } from "../../../utils/constants";
import "../index.scoped.css";
import { CASINO_VIDEO, getPointsFromCard, getProfit } from "../CasinoGeneric";
import { useDispatch, useSelector } from "react-redux";
import { getButtonValuesAPI } from "../../../service/AuthService";
import {
  casinoPL,
  cricketFancyPL,
  cricketMatchOddsPL,
} from "../../game/profitLoss";
import {
  casinoBetAPI,
  getCasinoBetsAPI,
  getCasinoLastTenResultAPI,
  getCasinoVideoUrlAPI,
  getIndividualResultCasinoAPI,
} from "../../../service/casino";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import TeenPattiRules from "./TeenPattiRules";
import AndarBahar2Rules from "./AndarBahar2Rules";
import BaccratRules from "./BaccaratRules";
import Baccrat2Rules from "./Baccarat2Rules";
import DTLRules from "./DTLRules";
import CasinoMeterRules from "./CasinoMeterRules";
import TeenPatti2020Rules from "./TeenPatti2020Rules";
import Card32A from "../Card32A";
import Card32ARules from "./Card32ARules";
import TeenPattiOneDayRules from "./TeenPattiOneDayRules";
import Card32BRules from "./Card32BRules";
import AmarAkbarRules from "./AmarAkbarRules";
import BTableRules from "./BTableRules";
import CricketMatch20Rules from "./CricketMatch20Rules";
import GenericIndividualResult from "./GenericIndividualResult";
import leftarrow from "../../../assets/left-arrow.png";
import rightarrow from "../../../assets/right-arrow.png";
export default function CasinoPage({
  gameName,
  GAME_ID,
  children,
  casino,
  VIDEO_ID,
  shortName,
  rule = false,
}) {
     const modalRef = React.useRef();
     const selectedEventForBet = useSelector(
       (state) => state.gameData.selectedEventForBet
     );
     const [selectedTab, setSelectedTab] = React.useState(0);
     const [buttons, setButtons] = React.useState([]);
     const [showRules, setShowRules] = React.useState(false);
     const [isLoading, setIsLoading] = React.useState(false);
     const [iframeUrl, setIframeUrl] = useState();
     const dispatch = useDispatch();
     const [individualResult, setIndividualResult] = React.useState(null);
     const andarRef = useRef(null); // Ref for Andar carousel
     const baharRef = useRef(null); // Ref for Bahar carousel
     const getCasinoIframeVideo = async () => {
       const { data } = await getCasinoVideoUrlAPI(GAME_ID);
       setIframeUrl(data);
     };
     useEffect(() => {
       getCasinoIframeVideo();
     }, [GAME_ID]);
     const handleScroll = (ref, direction) => {
       if (ref.current) {
         const scrollAmount = 200; // Adjust based on card width
         ref.current.scrollBy({
           left: direction === "next" ? scrollAmount : -scrollAmount,
           behavior: "smooth",
         });
       }
     };

     const ruleMap = {
       tp20: <TeenPattiRules />,
       fiveCricket:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/cricketv3.jpg",
       "super-over":
         "https://sitethemedata.com/v3/static/front/img/casino-rules/superover.jpg",
       race20:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/race20.jpg",
       ab2: <AndarBahar2Rules />,
       dt20:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/dt202.jpg",
       baccarat: <BaccratRules />,
       "baccarat baccarat2game": <Baccrat2Rules />,
       "casino-war":
         "https://sitethemedata.com/v3/static/front/img/casino-rules/war.jpg",
       dtl20: <DTLRules />,
       poker6player:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/poker6.jpg",
       cmeter: <CasinoMeterRules />,
       teenpattiopen:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/teen6.jpg",
       teenpatti20: <TeenPatti2020Rules />,
       cards32a: <Card32ARules />,
       teenpattitest:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/teen6.jpg",
       dt1day:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/dt6.jpg",
       teenpatti1day: <TeenPattiOneDayRules />,
       "cards32a poker-20 Poker_oneday":
         "https://sitethemedata.com/v3/static/front/img/casino-rules/poker6.jpg",
       "cards32a poker-20":
         "https://sitethemedata.com/v3/static/front/img/casino-rules/poker6.jpg",
       dt20:
         "https://sitethemedata.com/v3/static/front/img/casino-rules/dt202.jpg",
       "cards32a cards32b": <Card32BRules />,
       aaa: <AmarAkbarRules />,
       bollywood: <BTableRules />,
       cricket20: <CricketMatch20Rules />,
     };
     const casinoList = [
       {
         _id: 1,
         gameName: "3 Patti T20",
         gameCode: "TEEN_20",
         streamCode: "T20",
       },
       {
         _id: 2,
         gameName: "3 Patti Test",
         gameCode: "TEEN_9",
         streamCode: "TeenPattiTest",
       },
       {
         _id: 3,
         gameName: "3 Patti One Day",
         gameCode: "TEEN",
         streamCode: "TeenPatti1Day",
       },
       {
         _id: 4,
         gameName: "Poker- 1 Day",
         gameCode: "POKER_1_DAY",
         streamCode: "Poker1Day",
       },
       {
         _id: 5,
         gameName: "Poker- 20-20",
         gameCode: "POKER_20",
         streamCode: "Poker20",
       },
       {
         _id: 6,
         gameName: "6pp -> 6 Player Poker",
         gameCode: "POKER_9",
         streamCode: "",
       },
       {
         _id: 7,
         gameName: "Ander Bahar",
         gameCode: "AB_20",
         streamCode: "AndarBaharA",
       },
       {
         _id: 8,
         gameName: "DragonTiger- 1 Day",
         gameCode: "DRAGON_TIGER_6",
         streamCode: "DT6OneDay",
       },
       {
         _id: 9,
         gameName: "DRAGON TIGER- 20-20",
         gameCode: "DRAGON_TIGER_20",
         streamCode: "DT20",
       },
       {
         _id: 10,
         gameName: "20-20 DRAGON TIGER LION",
         gameCode: "DRAGON_TIGER_LION_20",
         streamCode: "DTL",
       },
       {
         _id: 11,
         gameName: "Amar Akbar Anthony",
         gameCode: "AAA",
         streamCode: "AAA",
       },
       {
         _id: 12,
         gameName: "Lucky 7 A",
         gameCode: "LUCKY7",
         streamCode: "Lucky7A",
       },
       {
         _id: 13,
         gameName: "Lucky7B",
         gameCode: "LUCKY7EU",
         streamCode: "Lucky7B",
       },
       {
         _id: 14,
         gameName: "Five Five Cricket",
         gameCode: "CRICKET_V3",
         streamCode: "Cricket5",
       },
       {
         _id: 15,
         gameName: "Super Over",
         gameCode: "SUPEROVER",
         streamCode: "SuperOver",
       },
       {
         _id: 16,
         gameName: "32card B",
         gameCode: "CARD32EU",
         streamCode: "32CardB",
       },
       {
         _id: 17,
         gameName: "32card A",
         gameCode: "CARD_32",
         streamCode: "32CardA",
       },
       {
         _id: 18,
         gameName: "Race 2020",
         gameCode: "RACE20",
         streamCode: "Race20",
       },
       {
         _id: 19,
         gameName: "Ander Bahar 2",
         gameCode: "ABJ",
         streamCode: "AndarBaharB",
       },
       {
         _id: 20,
         gameName: "BollyWood Table",
         gameCode: "BOLLYWOOD_TABLE",
         streamCode: "BollywoodTable",
       },
       {
         _id: 21,
         gameName: "Instant Worli",
         gameCode: "WORLI2",
         streamCode: "InstantWorli",
       },
       {
         _id: 22,
         gameName: "BACCARAT1",
         gameCode: "BACCARAT",
         streamCode: "m8l84cuz",
       },
       {
         _id: 23,
         gameName: "BACCARAT2",
         gameCode: "BACCARAT2",
         streamCode: "BaccaratB",
       },
       {
         _id: 24,
         gameName: "OpenTeenPatti",
         gameCode: "TEEN_8",
         streamCode: "",
       },
       {
         _id: 25,
         gameName: "CasinoWar",
         gameCode: "CASINO_WAR",
         streamCode: "War",
       },
       {
         _id: 26,
         gameName: "20-20 CRICKET MATCH",
         gameCode: "CRICKET_MATCH_20",
         streamCode: "2020Cricket",
       },
       {
         _id: 27,
         gameName: "20-20 DT 2",
         gameCode: "DRAGON_TIGER_20_2",
         streamCode: "DT20",
       },
        {
         _id: 28,
         gameName: "Amar Akbar Anthony 2",
         gameCode: "aaa2",
         streamCode: "aaa2",
       },
     ];
     const getCasinoId = () => {
       return casinoList?.find((item) => item?.gameCode == GAME_ID)
         ?.streamCode;
     };
     const handleAmountChange = (amount = DEFAULT_BET_AMOUNT) => {
       let calculation;

       calculation = casinoPL(
         selectedEventForBet?.selectedOdd,
         amount,
         selectedEventForBet?.type
       );
       dispatch({
         type: "gameData/setSelectedEventForBet",
         payload: {
           ...selectedEventForBet,
           amount,
           profit: calculation.profit,
           loss: calculation.loss,
         },
       });
     };
     const getButtonValues = async () => {
       const { response, code } = await getButtonValuesAPI();
       if (code == 200) {
         const convertedData = {
           casino: [],
           sport: [],
         };
         for (const key in response) {
           if (key.startsWith("buttonValueCasino")) {
             const index = key.replace("buttonValueCasino", "");
             const label = response["buttonNameCasino" + index];
             const value = response[key];
             convertedData.casino.push({
               label,
               value,
             });
           } else if (key.startsWith("buttonValue")) {
             const index = key.replace("buttonValue", "");
             const label = response["buttonName" + index];
             const value = response[key];
             convertedData.sport.push({
               label,
               value,
             });
           }
         }
         localStorage.setItem("buttonValues", JSON.stringify(convertedData));
         setButtons(convertedData);
       }
     };
     let game = "casino";
     const betPlace = async () => {
       let delay = 1500;
       setIsLoading(true);
       setTimeout(async () => {
         let selectedAmount_ = selectedEventForBet?.amount;
         if (selectedEventForBet.selectedOdd <= 0) {
           toast.error("Please select a Valid Odd");
           setIsLoading(false);
           return;
         }

         let payload = {
           amount: selectedAmount_,
           marketId: selectedEventForBet?.marketId,
           runnerName: selectedEventForBet?.runnerName,
           selectionId: selectedEventForBet?.selectedId,
           casinoGames: GAME_ID,
           back: selectedEventForBet?.selectedOdd,
           run: selectedEventForBet?.run,
           type: selectedEventForBet?.type,
         };
         if (
           GAME_ID != "CRICKET_V3" ||
           GAME_ID != "SUPEROVER" ||
           GAME_ID != "RACE20"
         ) {
           payload.profit = getProfit(
             selectedAmount_,
             game,
             selectedEventForBet
           )?.profit;
           payload.loss = getProfit(
             selectedAmount_,
             game,
             selectedEventForBet
           )?.loss;
         }

         if (
           GAME_ID == "CRICKET_V3" ||
           GAME_ID == "SUPEROVER" ||
           GAME_ID == "RACE20"
         ) {
           if (selectedEventForBet?.takeSize) {
             payload.profit = cricketFancyPL(
               selectedEventForBet?.selectedOdd,
               selectedAmount_,
               selectedEventForBet?.isBack ? "yes" : "no"
             )?.profit;
             payload.loss = cricketFancyPL(
               selectedEventForBet?.selectedOdd,
               selectedAmount_,
               selectedEventForBet?.isBack ? "yes" : "no"
             )?.loss;
           } else {
             payload.profit = getProfit(
               selectedAmount_,
               game,
               selectedEventForBet
             )?.profit;
             payload.loss = getProfit(
               selectedAmount_,
               game,
               selectedEventForBet
             )?.loss;
           }
         }

         if (selectedEventForBet?.type === "lay") {
           delete payload.back;
           payload.lay = selectedEventForBet?.selectedOdd;
         }
         // if (GAME_ID === "RACE20") {
         //   let calculation = cricketMatchOddsPL(
         //     selectedEventForBet?.selectedOdd,
         //     selectedAmount_,
         //     selectedEventForBet?.type
         //   );
         //   payload.profit = parseFloat(calculation?.profit).toFixed(2);

         //   payload.loss = parseFloat(calculation?.loss).toFixed(2);
         // }

         let { data, response, status, code } = await casinoBetAPI(payload);
         if (code == 200) {
           toast.success("Bet Placed");
         } else if (code == 500) {
           toast.error(status);
         } else if (code == "ERR_BAD_RESPONSE") {
           toast.error(status);
         } else {
           toast.error(status);
         }

         dispatch({
           type: "gameData/setSelectedEventForBet",
           payload: null,
         });
         setIsLoading(false);
       }, delay);
     };
     const casinoBets = useQuery(
       "casinoBets",
       () => getCasinoBetsAPI(GAME_ID),
       {
         refetchInterval: 2500,
       }
     );
     useEffect(() => {
       //close modal on outside click
       document.addEventListener("mousedown", handleOutSideClick);
       return () => {
         document.removeEventListener("mousedown", handleOutSideClick);
       };
     }, []);
     const handleOutSideClick = (e) => {
       if (modalRef.current && !modalRef.current.contains(e.target)) {
         dispatch({
           type: "gameData/setSelectedEventForBet",
           payload: null,
         });
       }
     };

     const lastTenResultData = useQuery(
       "getResult",
       () => getCasinoLastTenResultAPI(GAME_ID),
       {
         refetchInterval: 1500,
       }
     );
     const isMobile = window.innerWidth < 1024;
     React.useEffect(() => {
       getButtonValues();
     }, []);
     const splitDigit = (isFirst) => {
       if (!casino || !casino?.response || !casino?.response?.autoTime)
         return "00";
       let digits = casino?.response?.autoTime?.split("");
       if (digits.length === 1) {
         digits.unshift("0");
       }
       return isFirst ? digits[1] : digits[0];
     };
     const casinoCardMap = (_) => {
       let cardMap = {
         cmeter: "",
         queen: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div className="casino-video-cards">
               <div>
                 <h5 className="">Total 0</h5>
                 <div className="flip-card-container">
                   {casino?.response?.cards &&
                     casino?.response?.cards[0]?.map(
                       (item) =>
                         item != "1" && (
                           <div className="flip-card">
                             <div className="flip-card-inner ">
                               <div className="flip-card-front">
                                 <img
                                   src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                                 />
                               </div>
                               <div className="flip-card-back">
                                 <img
                                   src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                                 />
                               </div>
                             </div>
                           </div>
                         )
                     )}
                 </div>
               </div>
               <div>
                 <h5 className="">Total 1</h5>
                 <div className="flip-card-container">
                   {casino?.response?.cards &&
                     casino?.response?.cards[1]?.map((item) => (item) =>
                       item != "1" && (
                         <div className="flip-card">
                           <div className="flip-card-inner ">
                             <div className="flip-card-front">
                               <img
                                 src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                             <div className="flip-card-back">
                               <img
                                 src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                           </div>
                         </div>
                       )
                     )}
                 </div>
               </div>
               <div>
                 <h5 className="">Total 2</h5>
                 <div className="flip-card-container">
                   {casino?.response?.cards &&
                     casino?.response?.cards[2]?.map((item) => (item) =>
                       item != "1" && (
                         <div className="flip-card">
                           <div className="flip-card-inner ">
                             <div className="flip-card-front">
                               <img
                                 src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                             <div className="flip-card-back">
                               <img
                                 src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                           </div>
                         </div>
                       )
                     )}
                 </div>
               </div>
               <div>
                 <h5 className="">Total 3</h5>
                 <div className="flip-card-container">
                   {casino?.response?.cards &&
                     casino?.response?.cards[3]?.map((item) => (item) =>
                       item != "1" && (
                         <div className="flip-card">
                           <div className="flip-card-inner ">
                             <div className="flip-card-front">
                               <img
                                 src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                             <div className="flip-card-back">
                               <img
                                 src={`https://versionobj.ecoassetsservice.com/v21/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                           </div>
                         </div>
                       )
                     )}
                 </div>
               </div>
             </div>
           ),
         "casino-war": casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div className="casino-video-cards">
               {casino?.response?.cards && (
                 <div className="flip-card">
                   <div className="flip-card-inner ">
                     <div className="flip-card-front">
                       <img
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${
                           casino?.response?.cards[6]
                         }.jpg`}
                       />
                     </div>
                     <div className="flip-card-back">
                       <img
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${
                           casino?.response?.cards[6]
                         }.jpg`}
                       />
                     </div>
                   </div>
                 </div>
               )}
             </div>
           ),
         cricketMatch20: casino?.response?.cards && (
           <div className="casino-video-cards">
             {casino?.response?.cards &&
               casino?.response?.cards[0]?.map((item) => (
                 <div className="flip-card">
                   <div className="flip-card-inner ">
                     <div className="flip-card-front">
                       <img
                         src={`https://versionobj.ecoassetsservice.com/v22/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                     <div className="flip-card-back">
                       <img
                         src={`https://versionobj.ecoassetsservice.com/v22/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   </div>
                 </div>
               ))}
           </div>
         ),
         baccarat: "",
        //  "ab ab3": casino?.response?.cards &&
        //    casino?.response?.cards.length > 1 &&
        //    casino?.response?.cards[0].length > 0 &&
        //    casino?.response?.cards[1].length > 0 &&
        //    casino?.response?.cards[1]?.length > 0 &&
        //    !(
        //      casino.response.cards[0].length === 1 &&
        //      casino.response.cards[0][0] === ""
        //    ) &&
          //  !(
          //    casino.response.cards[1].length === 1 &&
          //    casino.response.cards[1][0] === ""
       //  ) && (
         "ab ab3":
  casino?.response?.cards &&
  casino.response.cards.length > 1 &&
  casino.response.cards[0] &&
  casino.response.cards[1] &&
  casino.response.cards[0].length > 0 &&
  casino.response.cards[1].length > 0 &&
  !(
    casino.response.cards[0].length === 1 &&
    casino.response.cards[0][0] === ""
  ) &&
  !(
    casino.response.cards[1].length === 1 &&
    casino.response.cards[1][0] === ""
  ) && (
    // ✅ Your JSX or return value here

             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-3 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ab-cards-container ng-tns-c1798067373-3 ng-star-inserted"
               >
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="row row5 align-items-center ng-tns-c1798067373-3"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="col-12 ng-tns-c1798067373-3"
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row row5 mb-1 ng-tns-c1798067373-3 ng-star-inserted"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-12 ng-tns-c1798067373-3"
                       >
                         Andar
                       </div>
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-lg-12 col-12 ng-tns-c1798067373-3"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="casino-result-cards col-lg-12 ng-tns-c1798067373-3"
                         >
                           {/**/}
                           {/**/}
                           <button
                             _ngcontent-ng-c1798067373=""
                             type="button"
                             onClick={() =>
                               handleScroll(andarRef, "prev")
                             }
                             className="ab-pervious d-block ng-tns-c1798067373-3 ng-star-inserted"
                           >
                             <img
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-3"
                               src={leftarrow}
                             />
                           </button>
                           {/**/}
                           <button
                             _ngcontent-ng-c1798067373=""
                             type="button"
                             onClick={() =>
                               handleScroll(andarRef, "next")
                             }
                             className="ab-next d-block ng-tns-c1798067373-3 ng-star-inserted"
                           >
                             <img
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-3"
                               src={rightarrow}
                             />
                           </button>
                           {/**/}
                           <div
                             _ngcontent-ng-c1798067373=""
                             className="casino-result-cardimg andharbahar1 ng-tns-c1798067373-3"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="andharbahar1_slide ng-tns-c1798067373-3"
                               ref={andarRef}
                               style={{
                                 display: "flex",
                                 overflowX: "auto",
                               }}
                             >
                               {casino?.response?.cards &&
                                 casino?.response?.cards[0]?.map(
                                   (item) => (
                                     <div
                                       _ngcontent-ng-c1798067373=""
                                       className="slide ng-tns-c1798067373-3 ng-star-inserted"
                                     >
                                       <img
                                         _ngcontent-ng-c1798067373=""
                                         className="ng-tns-c1798067373-3"
                                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                       />
                                     </div>
                                   )
                                 )}

                               {/**/}
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     {/**/}
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row row5 ng-tns-c1798067373-3 ng-star-inserted"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-12 ng-tns-c1798067373-3"
                       >
                         Bahar
                       </div>
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-lg-12 col-12 ng-tns-c1798067373-3"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="casino-result-cards col-lg-12 ng-tns-c1798067373-3"
                         >
                           {/**/}
                           {/**/}
                           <button
                             _ngcontent-ng-c1798067373=""
                             type="button"
                             onClick={() =>
                               handleScroll(baharRef, "prev")
                             }
                             className="ab-pervious d-block ng-tns-c1798067373-3 ng-star-inserted"
                           >
                             <img
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-3"
                               src={leftarrow}
                             />
                           </button>
                           {/**/}
                           <button
                             _ngcontent-ng-c1798067373=""
                             type="button"
                             onClick={() =>
                               handleScroll(baharRef, "next")
                             }
                             className="ab-next d-block ng-tns-c1798067373-3 ng-star-inserted"
                           >
                             <img
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-3"
                               src={rightarrow}
                             />
                           </button>
                           {/**/}
                           <div
                             _ngcontent-ng-c1798067373=""
                             className="casino-result-cardimg andharbahar1 ng-tns-c1798067373-3"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="andharbahar1_slide ng-tns-c1798067373-3"
                               ref={baharRef}
                               style={{
                                 display: "flex",
                                 overflowX: "auto",
                               }}
                             >
                               {casino?.response?.cards &&
                                 casino?.response?.cards[1]?.map(
                                   (item) => (
                                     <div
                                       _ngcontent-ng-c1798067373=""
                                       className="slide ng-tns-c1798067373-3 ng-star-inserted"
                                     >
                                       <img
                                         _ngcontent-ng-c1798067373=""
                                         className="ng-tns-c1798067373-3"
                                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                       />
                                     </div>
                                   )
                                 )}
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     {/**/}
                   </div>
                 </div>
               </div>
               {/**/}
             </div>
           ),
         teenpatti20: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-12 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-12 ng-star-inserted"
               >
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-12 ng-star-inserted"
                 >
                   PLAYER A
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-12 ng-star-inserted"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[0]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="me-lg-2 me-1 ng-tns-c1798067373-12 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-12"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}
                 </div>
               </div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-12 ng-star-inserted"
               >
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-12 ng-star-inserted"
                 >
                   PLAYER B
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-12 ng-star-inserted"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[1]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="me-lg-2 me-1 ng-tns-c1798067373-12 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-12"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}
                 </div>
               </div>
             </div>
           ),
         "cards32a poker-20": (
           <div
             _ngcontent-ng-c1798067373=""
             className="casino-video-cards ng-tns-c1798067373-13 ng-star-inserted"
           >
             <div
               _ngcontent-ng-c1798067373=""
               className="mb-lg-2 mb-1 d-flex justify-content-between align-items-center ng-tns-c1798067373-13"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-13"
               >
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-13"
                 >
                   PLAYER A
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-13"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[0]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="me-lg-2 me-1 ng-tns-c1798067373-13 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-13"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}

                   {/**/}
                 </div>
               </div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-13"
               >
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="text-end ng-tns-c1798067373-13"
                 >
                   PLAYER B
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-13"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[1]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="ms-lg-2 ms-1 ng-tns-c1798067373-13 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-13"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}

                   {/**/}
                 </div>
               </div>
             </div>
             <h5
               _ngcontent-ng-c1798067373=""
               className="ng-tns-c1798067373-13"
             >
               BOARD
             </h5>
             <div
               _ngcontent-ng-c1798067373=""
               className="flip-card-container ng-tns-c1798067373-13"
             >
               {casino?.response?.cards &&
                 casino?.response?.cards[2]?.map((item) => (
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="me-lg-2 me-1 mb-1 ng-tns-c1798067373-13 ng-star-inserted"
                   >
                     <img
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-13"
                       src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                     />
                   </div>
                 ))}
             </div>
           </div>
         ),
         teenpattitest: casino?.response?.cards &&
           casino?.response?.cards.length > 1 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-14 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-14 ng-star-inserted"
               >
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-14 ng-star-inserted"
                 >
                   {" "}
                   TIGER
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-14 ng-star-inserted"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[0]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="me-lg-2 me-1 ng-tns-c1798067373-14 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-14"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}
                 </div>
                 {/**/}
                 {/**/}
                 {/**/}
                 {/**/}
               </div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-14 ng-star-inserted"
               >
                 {/**/}
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-14 ng-star-inserted"
                 >
                   LION
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-14 ng-star-inserted"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[1]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="me-lg-2 me-1 ng-tns-c1798067373-14 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-14"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}
                 </div>
                 {/**/}
                 {/**/}
                 {/**/}
               </div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-14 ng-star-inserted"
               >
                 {/**/}
                 {/**/}
                 <h5
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-14 ng-star-inserted"
                 >
                   {" "}
                   DRAGON
                 </h5>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-14 ng-star-inserted"
                 >
                   {casino?.response?.cards &&
                     casino?.response?.cards[2]?.map((item) => (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="me-lg-2 me-1 ng-tns-c1798067373-14 ng-star-inserted"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-14"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     ))}
                 </div>
                 {/**/}
                 {/**/}
               </div>
               {/**/}
             </div>
           ),
         race20: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div className="casino-video-cards">
               <div>
                 <div className="flip-card-container">
                   <div
                     style={{
                       padding: 0,
                       margin: 0,
                     }}
                     className="flip-card"
                   >
                     <img src="https://versionobj.ecoassetsservice.com/v19/static/front/img/icons/spade.png" />
                   </div>
                   {/* {casino?.response?.cards &&
                     casino?.response?.cards.length > 0 &&
                     casino?.response?.cards[0].length > 0 &&
                     casino?.response?.cards[0].map((item) => ( */}
                 {casino?.response?.cards &&
  casino?.response?.cards.length > 0 &&
  casino?.response?.cards[0] &&
  casino.response.cards[0].length > 0 &&
  casino.response.cards[0].map((item, i) => (
                       <div className="flip-card">
                         <div className="flip-card-inner ">
                           <div className="flip-card-front">
                             <img
                               src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                             />
                           </div>
                           <div className="flip-card-back">
                             <img
                               src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                             />
                           </div>
                         </div>
                       </div>
                     ))}
                 </div>
               </div>
               <div className="mt-1">
                 <div className="flip-card-container">
                   <div
                     style={{
                       padding: 0,
                       margin: 0,
                     }}
                     className="flip-card"
                   >
                     <img src="https://versionobj.ecoassetsservice.com/v19/static/front/img/icons/heart.png" />
                   </div>
                   {/* {casino?.response?.cards &&
                     casino?.response?.cards.length > 0 &&
                     casino?.response?.cards[1]?.length > 0 &&
                     casino?.response?.cards[1]?.map((item) => ( */}
                 {casino?.response?.cards &&
                   casino?.response?.cards.length > 0 &&
                   casino?.response?.cards[1] &&
                   casino.response.cards[1].length > 0 &&
                   casino.response.cards[1].map((item) => (
                   <div className="flip-card">
                     <div className="flip-card-inner ">
                       <div className="flip-card-front">
                         <img
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                       <div className="flip-card-back">
                         <img
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                         />
                       </div>
                     </div>
                   </div>
                   ))}
                 </div>
               </div>
               <div className="mt-1">
                 <div className="flip-card-container">
                   <div
                     style={{
                       padding: 0,
                       margin: 0,
                     }}
                     className="flip-card"
                   >
                     <img src="https://versionobj.ecoassetsservice.com/v19/static/front/img/icons/club.png" />
                   </div>
                   {/* {casino?.response?.cards &&
                     casino?.response?.cards?.length > 2 &&
                     casino?.response?.cards[2]?.length > 0 &&
                     casino?.response?.cards[2]?.map((item) => ( */}
                 {casino?.response?.cards &&
  casino?.response?.cards.length > 2 &&
  casino?.response?.cards[2] &&
  casino.response.cards[2].length > 0 &&
  casino.response.cards[2].map((item, i) => (
                       <div className="flip-card">
                         <div className="flip-card-inner ">
                           <div className="flip-card-front">
                             <img
                               src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                             />
                           </div>
                           <div className="flip-card-back">
                             <img
                               src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                             />
                           </div>
                         </div>
                       </div>
                     ))}
                 </div>
               </div>
               <div className="mt-1">
                 <div className="flip-card-container">
                   <div
                     style={{
                       padding: 0,
                       margin: 0,
                     }}
                     className="flip-card"
                   >
                     <img src="https://versionobj.ecoassetsservice.com/v19/static/front/img/icons/diamond.png" />
                   </div>
                   {/* {casino?.response?.cards &&
                     casino?.response?.cards?.length > 2 &&
                     casino?.response?.cards[3]?.length > 0 &&
                     casino?.response?.cards[3]?.map((item) => ( */}
                 {casino?.response?.cards &&
casino?.response?.cards?.length > 2 &&
casino?.response?.cards[3]?.length > 0 &&
casino?.response?.cards[3]?.map((item) => (
                       <div className="flip-card">
                         <div className="flip-card-inner ">
                           <div className="flip-card-front">
                             <img
                               src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                             />
                           </div>
                           <div className="flip-card-back">
                             <img
                               src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                             />
                           </div>
                         </div>
                       </div>
                     ))}
                 </div>
               </div>
             </div>
           ),
        //  cards32a: casino?.response?.cards &&
       //    casino?.response?.cards.length > 0 && (
        cards32a: casino?.response?.cards &&
        casino.response.cards &&
        casino.response.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-11 ng-star-inserted"
             >
               {/* {casino?.response?.cards &&
                 casino?.response?.cards.length > 0 &&
                 casino?.response?.cards[0].length > 0 && ( */}
            {casino?.response?.cards &&
casino?.response?.cards.length > 0 &&
casino?.response?.cards[0] &&
casino.response.cards[0].length > 0 && (
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-11 ng-star-inserted"
                   >
                     <h5
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-11 ng-star-inserted"
                     >
                       {" "}
                       Player 8:{" "}
                       <span
                         _ngcontent-ng-c1798067373=""
                         className="text-warning ng-tns-c1798067373-11 ng-star-inserted"
                       >
                         {0}
                       </span>
                     </h5>

                     <div
                       _ngcontent-ng-c1798067373=""
                       className="flip-card-container ng-tns-c1798067373-11 ng-star-inserted"
                     >
                       {casino?.response?.cards[0]?.map(
                         (item) =>
                           item != "1" && (
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="flip-card ng-tns-c1798067373-11"
                             >
                               <div
                                 style={{
                                   width: "20px",
                                 }}
                                 _ngcontent-ng-c1798067373=""
                                 className="flip-card-inner ng-tns-c1798067373-11"
                               >
                                 <div
                                   _ngcontent-ng-c1798067373=""
                                   className="flip-card-front ng-tns-c1798067373-11"
                                 >
                                   <img
                                     _ngcontent-ng-c1798067373=""
                                     className="ng-tns-c1798067373-11"
                                     src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                   />
                                 </div>
                               </div>
                             </div>
                           )
                       )}
                     </div>
                   </div>
                 )}

               <div
                 _ngcontent-ng-c1798067373=""
                 className="mt-1 ng-tns-c1798067373-11"
               >
                 <h5
                   style={{ marginTop: 30 }}
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-11 text-success ng-star-inserted"
                 >
                   {" "}
                   Player 9:{" "}
                   <span
                     _ngcontent-ng-c1798067373=""
                     className="text-warning ng-tns-c1798067373-11 ng-star-inserted"
                   >
                     {0}
                   </span>
                 </h5>

                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-11 ng-star-inserted"
                 >
                   {casino?.response?.cards[1]?.map(
                     (item) =>
                       item != "1" && (
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="flip-card ng-tns-c1798067373-11"
                         >
                           <div
                             style={{
                               width: "20px",
                             }}
                             _ngcontent-ng-c1798067373=""
                             className="flip-card-inner ng-tns-c1798067373-11"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="flip-card-front ng-tns-c1798067373-11"
                             >
                               <img
                                 _ngcontent-ng-c1798067373=""
                                 className="ng-tns-c1798067373-11"
                                 src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                           </div>
                         </div>
                       )
                   )}
                 </div>
               </div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="mt-1 ng-tns-c1798067373-11"
               >
                 <h5
                   style={{ marginTop: 30 }}
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-11 ng-star-inserted"
                 >
                   {" "}
                   Player 10:{" "}
                   <span
                     _ngcontent-ng-c1798067373=""
                     className="text-warning ng-tns-c1798067373-11 ng-star-inserted"
                   >
                     {0}
                   </span>
                 </h5>

                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-11 ng-star-inserted"
                 >
                   {casino?.response?.cards[2]?.map(
                     (item) =>
                       item != "1" && (
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="flip-card ng-tns-c1798067373-11"
                         >
                           <div
                             style={{
                               width: "20px",
                             }}
                             _ngcontent-ng-c1798067373=""
                             className="flip-card-inner ng-tns-c1798067373-11"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="flip-card-front ng-tns-c1798067373-11"
                             >
                               <img
                                 _ngcontent-ng-c1798067373=""
                                 className="ng-tns-c1798067373-11"
                                 src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                           </div>
                         </div>
                       )
                   )}
                 </div>
               </div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="mt-1 ng-tns-c1798067373-11"
               >
                 <h5
                   _ngcontent-ng-c1798067373=""
                   style={{ marginTop: 30 }}
                   className="ng-tns-c1798067373-11 ng-star-inserted"
                 >
                   {" "}
                   Player 11:{" "}
                   <span
                     _ngcontent-ng-c1798067373=""
                     className="text-warning ng-tns-c1798067373-11 ng-star-inserted"
                   >
                     {0}
                   </span>
                 </h5>

                 <div
                   _ngcontent-ng-c1798067373=""
                   className="flip-card-container ng-tns-c1798067373-11 ng-star-inserted"
                 >
                   {casino?.response?.cards[3]?.map(
                     (item) =>
                       item != "1" && (
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="flip-card ng-tns-c1798067373-11"
                         >
                           <div
                             style={{
                               width: "20px",
                             }}
                             _ngcontent-ng-c1798067373=""
                             className="flip-card-inner ng-tns-c1798067373-11"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="flip-card-front ng-tns-c1798067373-11"
                             >
                               <img
                                 _ngcontent-ng-c1798067373=""
                                 className="ng-tns-c1798067373-11"
                                 src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                               />
                             </div>
                           </div>
                         </div>
                       )
                   )}
                 </div>
               </div>
             </div>
           ),
         dt1day: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="flip-card-container ng-tns-c1798067373-0"
               >
                 {casino?.response?.cards &&
                   casino?.response?.cards[0]?.map((item) => (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <img
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   ))}
                 {casino?.response?.cards &&
                   casino?.response?.cards[1]?.map((item) => (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <img
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   ))}
               </div>
             </div>
           ),
         worli: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="flip-card-container ng-tns-c1798067373-0"
               >
                 {casino?.response?.cards &&
                   casino?.response?.cards[0]?.map((item) => (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <img
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   ))}
                 {casino?.response?.cards &&
                   casino?.response?.cards[1]?.map((item) => (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <img
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   ))}
                 {casino?.response?.cards &&
                   casino?.response?.cards[2]?.map((item) => (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <img
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   ))}
               </div>
             </div>
           ),
         teenpattiopen: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="flip-card-container ng-tns-c1798067373-0"
               >
                 {casino?.response?.cards &&
                   casino?.response?.cards[8]?.map((item) => (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <img
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                       />
                     </div>
                   ))}
               </div>
             </div>
           ),
         ab2: casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ab-cards-container ng-tns-c1798067373-0"
               >
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="row row5 align-items-center ng-tns-c1798067373-0"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="col-1 ng-tns-c1798067373-0"
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row row5 ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-12 ng-tns-c1798067373-0"
                       >
                         <b
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-0"
                         >
                           A
                         </b>
                       </div>
                     </div>
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row row5 ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-12 ng-tns-c1798067373-0"
                       >
                         <b
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-0"
                         >
                           B
                         </b>
                       </div>
                     </div>
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="col-2 ng-tns-c1798067373-0"
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="flip-card ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="flip-card-inner ng-tns-c1798067373-0"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="flip-card-front ng-tns-c1798067373-0"
                         >
                           <img
                             _ngcontent-ng-c1798067373=""
                             className="ng-tns-c1798067373-0"
                            //  src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${
                            //    casino?.response?.cards[0][0]
                           //  }.jpg`}
                           src={
                            casino?.response?.cards &&
                            casino.response.cards.length > 0 &&
                            Array.isArray(casino.response.cards[0]) &&
                            casino.response.cards[0].length > 0
                              ? `https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${casino.response.cards[0][0]}.jpg`
                              : "" // fallback empty string or a default image path
                          }
                          
                           />
                         </div>
                       </div>
                     </div>
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="col-9 ng-tns-c1798067373-0 ng-star-inserted"
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row row5 mb-1 ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-lg-10 col-9 ng-tns-c1798067373-0"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="casino-result-cards col-lg-12 ng-tns-c1798067373-0"
                         >
                           <div
                             _ngcontent-ng-c1798067373=""
                             className="casino-result-cardimg ng-tns-c1798067373-0"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="andar-bhar2-cards-slider ng-tns-c1798067373-0"
                             >
                               {/**/}
                               {/**/}
                               {/**/}
                               {/**/}
                               <div
                                 _ngcontent-ng-c1798067373=""
                                 className="draggable ng-tns-c1798067373-0"
                               >
                                 {casino?.response?.cards[1]?.map(
                                   (item) =>
                                     item != "1" && (
                                       <img
                                         _ngcontent-ng-c1798067373=""
                                         onerror="this.src='assets/images/cards/1.jpg'"
                                         className="ng-tns-c1798067373-0"
                                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                       />
                                     )
                                 )}
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row row5 mb-1 ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-lg-10 col-9 ng-tns-c1798067373-0"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="casino-result-cards col-lg-12 ng-tns-c1798067373-0"
                         >
                           <div
                             _ngcontent-ng-c1798067373=""
                             className="casino-result-cardimg ng-tns-c1798067373-0"
                           >
                             <div
                               _ngcontent-ng-c1798067373=""
                               className="andar-bhar2-cards-slider ng-tns-c1798067373-0"
                             >
                               {/**/}
                               {/**/}
                               {/**/}
                               {/**/}
                               <div
                                 _ngcontent-ng-c1798067373=""
                                 className="draggable ng-tns-c1798067373-0"
                               >
                                 {casino?.response?.cards[2]?.map(
                                   (item) =>
                                     item != "1" && (
                                       <img
                                         _ngcontent-ng-c1798067373=""
                                         onerror="this.src='assets/images/cards/1.jpg'"
                                         className="ng-tns-c1798067373-0"
                                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                       />
                                     )
                                 )}
                                 {/**/}
                                 {/**/}
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                   {/**/}
                 </div>
               </div>
             </div>
           ),
         "super-over": casino?.response?.cards &&
           casino?.response?.cards.length > 0 && (
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-video-cards ng-tns-c1798067373-1 ng-star-inserted"
             >
               {casino?.response?.cards[0]?.map(
                 (item) =>
                   item != 1 && (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="mt-1 ng-tns-c1798067373-1 ng-star-inserted"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-1"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-1"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/superover/balls/${getPointsFromCard(
                             item
                           )}.png`}
                         />
                       </div>
                     </div>
                   )
               )}
               {casino?.response?.cards[1]?.map(
                 (item) =>
                   item != 1 && (
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="mt-1 ng-tns-c1798067373-1 ng-star-inserted"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-1"
                       >
                         <img
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-1"
                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/superover/balls/${getPointsFromCard(
                             item
                           )}.png`}
                         />
                       </div>
                     </div>
                   )
               )}
             </div>
           ),
       };
       if (shortName == "cards32a cards32b" || shortName == "teen41") {
         return cardMap["cards32a"];
       }
       if (shortName == "cards32a poker-20 Poker_oneday") {
         return cardMap["cards32a poker-20"];
       }

       if (shortName == "baccarat") {
         return "";
       }

       if (shortName == "teenpatti1day") {
         return cardMap.teenpatti20;
       }

       if (shortName == "fiveCricket") {
         return cardMap.cricketMatch20;
       }
       if (shortName == "cmeter") {
         return "";
       } else {
         return cardMap[_];
       }
     };
     const getIndividualResult = async (marketId) => {
       const { response } = await getIndividualResultCasinoAPI(
         marketId,
         casino?.response?.casinoGames
       );
       setIndividualResult(response);
     };
     let changeShortName = shortName;
     if(GAME_ID=="teen6"){
      changeShortName="teenpatti2"
     }
     if (GAME_ID == "teensin") {
       changeShortName = "baccarat29";
     }
  if (GAME_ID == "cards32") {
       changeShortName = "cards32a";
     }
     if (GAME_ID == "race2") {
       changeShortName = "queen";
     }
     if (GAME_ID == "teenjoker") {
       changeShortName = "teenpatti-joker";
     }
     if (GAME_ID == "teen20c") {
       changeShortName = "teenpatti20";
     }
     if (GAME_ID == "btable2") {
       changeShortName = "bollywood";
     }
     if (GAME_ID == "superover3") {
       changeShortName = "super-over";
     }
     if (GAME_ID == "goal") {
       changeShortName = "ball-by-ball goal";
     }
     if (GAME_ID == "joker20") {
       changeShortName = "teenpatti-joker";
     }
     if (GAME_ID == "joker1") {
       changeShortName = "teenpatti-joker1";
     }
     if (GAME_ID == "superover2") {
       changeShortName = "super-over super-over2";
     }
     if (GAME_ID == "lucky15") {
       changeShortName = "ball-by-ball";
     }
     if (GAME_ID == "teen41") {
       changeShortName = "teenpatti2";
     }
     if (GAME_ID == "sicbo") {
       changeShortName = "sicbo";
     }
     if (GAME_ID == "teen33") {
       changeShortName = "teen33";
     } 
     if (GAME_ID == "teen42") {
       changeShortName = "teenpatti2";
     }
     if (GAME_ID == "aaa2") {
       changeShortName = "aaa2";
     }
     if (GAME_ID == "aaa") {
       changeShortName = "aaa";
     }
     if (GAME_ID == "ab3") {
       changeShortName = "ab ab3";
     }
     if (GAME_ID == "ab4") {
       changeShortName = "ab ab3";
     }
     if (GAME_ID == "teen32") {
       changeShortName = "teenpatti1day";
     }

     if (GAME_ID == "teen33") {
       changeShortName = "teenpatti1day";
     }

     if (GAME_ID == "ballbyball") {
       changeShortName = " ball-by-ball";
     }

     if (GAME_ID == "poker6") {
       changeShortName = "poker6player";
     }

     if (GAME_ID == "kbc") {
       changeShortName = "kbc";
     }

     if (GAME_ID == "notenum") {
       changeShortName = "note-number";
     }

     if (GAME_ID == "trio") {
       changeShortName = "trio";
     }

     if (GAME_ID == "cmeter1") {
       changeShortName = "one-card-meter";
     }

     if (GAME_ID == "dum10") {
       changeShortName = "duskadum";
     }

     if (GAME_ID == "teen3") {
       changeShortName = "teenpatti1day";
     }

     if (GAME_ID == "race17") {
       changeShortName = "raceto17";
     }

     if (GAME_ID == "teenmuf") {
       changeShortName = "teenpattimuflis";
     }

     if (GAME_ID == "patti2") {
       changeShortName = "teenpatti2cards";
     }
if(GAME_ID=="worli"){
  changeShortName="worli"
}
     return (
       <div
         _ngcontent-ng-c1798067373=""
         className="center-main-container casino-page ng-tns-c1798067373-0 ng-star-inserted"
       >
         <div
           _ngcontent-ng-c1798067373=""
           className="center-container ng-tns-c1798067373-0"
         >
           <div
             _ngcontent-ng-c1798067373=""
             className={`casino-page-container ng-tns-c1798067373-0 ${changeShortName}`}
           >
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-title-header-mobile d-xl-none ng-tns-c1798067373-0"
             >
               <ul
                 _ngcontent-ng-c1798067373=""
                 className="nav nav-tabs menu-tabs ng-tns-c1798067373-0"
               >
                 <li
                   _ngcontent-ng-c1798067373=""
                   className="nav-item ng-tns-c1798067373-0"
                 >
                   <div
                     onClick={() => {
                       setSelectedTab(0);
                     }}
                     _ngcontent-ng-c1798067373=""
                     className={`ng-tns-c1798067373-0 ${
                       selectedTab === 0 ? "active" : ""
                     } nav-link`}
                   >
                     Game
                   </div>
                 </li>
                 <li
                   onClick={() => {
                     setSelectedTab(1);
                   }}
                   _ngcontent-ng-c1798067373=""
                   className="nav-item ng-tns-c1798067373-0"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className={`ng-tns-c1798067373-0 ${
                       selectedTab === 1 ? "active" : ""
                     } nav-link`}
                   >
                     {" "}
                     Placed Bet ({casinoBets?.data?.length}){" "}
                   </div>
                 </li>
               </ul>
               <div
                 _ngcontent-ng-c1798067373=""
                 className="pe-2 ng-tns-c1798067373-0"
               >
                 <span
                   _ngcontent-ng-c1798067373=""
                   className="casino-rid ng-tns-c1798067373-0"
                 >
                   {ruleMap[shortName] && (
                     <a
                       onClick={() => {
                         setShowRules(true);
                       }}
                       _ngcontent-ng-c1798067373=""
                       className="d-block ng-tns-c1798067373-0"
                     >
                       <small
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                       >
                         Rules
                       </small>
                     </a>
                   )}{" "}
                   Round ID:{" "}
                   <span
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0 ng-star-inserted"
                   >
                     {casino?.response?.marketId}
                   </span>
                 </span>
               </div>
             </div>
             <div
               _ngcontent-ng-c1798067373=""
               className="casino-header ng-tns-c1798067373-0"
             >
               <span
                 _ngcontent-ng-c1798067373=""
                 className="casino-name ng-tns-c1798067373-0"
               >
                 {" "}
                 {gameName}
                 {ruleMap[shortName] && (
                   <a
                     onClick={() => {
                       setShowRules(true);
                     }}
                     _ngcontent-ng-c1798067373=""
                     className="ms-1 d-xl-inline d-none ng-tns-c1798067373-0"
                   >
                     <small
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-0"
                     >
                       Rules
                     </small>
                   </a>
                 )}
               </span>
               <span
                 _ngcontent-ng-c1798067373=""
                 className="casino-rid d-none d-xl-inline-block ng-tns-c1798067373-0"
               >
                 <small
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-0"
                 >
                   Round ID:{" "}
                   <span
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0 ng-star-inserted"
                   >
                     {casino?.response?.marketId}
                   </span>
                 </small>
                 <span
                   _ngcontent-ng-c1798067373=""
                   className="ng-tns-c1798067373-0 ng-star-inserted"
                 >
                   {" "}
                   | Min: 100 | Max: 300000
                 </span>
               </span>
             </div>

             {selectedTab == 0 && (
               <div
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-0 ng-star-inserted"
               >
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="casino-video ng-tns-c1798067373-0"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="video-box-container ng-tns-c1798067373-0"
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="casino-video-box ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       <iframe
                         // referrerPolicy="no-referrer"
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                         // src={`${CASINO_VIDEO_URL + getCasinoId()}`}
                         src={iframeUrl}
                       />
                     </div>
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0 ng-star-inserted"
                   >
                     {shortName == "baccarat" ||
                     shortName == "baccarat baccarat2game" ||
                     shortName == "cmeter" ? null : casinoCardMap(
                         shortName
                       ) ? (
                       casinoCardMap(shortName)
                     ) : (
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="flip-card-container ng-tns-c1798067373-0"
                         >
                           {casino?.response?.cards &&
                             casino?.response?.cards[0]?.map((item) => (
                               <div
                                 _ngcontent-ng-c1798067373=""
                                 className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
                               >
                                 <img
                                   _ngcontent-ng-c1798067373=""
                                   className="ng-tns-c1798067373-0"
                                   src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                 />
                               </div>
                             ))}
                         </div>
                       </div>
                     )}
                   </div>

                   <div className="clock flip-clock-wrapper">
  <ul className="flip play">
    <li className="flip-clock-before">
      <a href="#">
        <div className="up">
          <div className="shadow" />
          <div className="inn"> {splitDigit(false)}</div>
        </div>
        <div className="down">
          <div className="shadow" />
          <div className="inn"> {splitDigit(false)}</div>
        </div>
      </a>
    </li>
    <li className="flip-clock-active">
      <a href="#">
        <div className="up">
          <div className="shadow" />
          <div className="inn"> {splitDigit(false)}</div>
        </div>
        <div className="down">
          <div className="shadow" />
          <div className="inn"> {splitDigit(false)}</div>
        </div>
      </a>
    </li>
  </ul>
  <ul className="flip play">
    <li className="flip-clock-before">
      <a href="#">
        <div className="up">
          <div className="shadow" />
          <div className="inn"> {splitDigit(true)}</div>
        </div>
        <div className="down">
          <div className="shadow" />
          <div className="inn"> {splitDigit(true)}</div>
        </div>
      </a>
    </li>
    <li className="flip-clock-active">
      <a href="#">
        <div className="up">
          <div className="shadow" />
          <div className="inn"> {splitDigit(true)}</div>
        </div>
        <div className="down">
          <div className="shadow" />
          <div className="inn">{splitDigit(true)}</div>
        </div>
      </a>
    </li>
  </ul>
</div>

                 </div>

                 <div
                   _ngcontent-ng-c1798067373=""
                   className="casino-detail ng-tns-c1798067373-0"
                 >
                   {children}

                   <div
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0"
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="casino-last-result-title ng-tns-c1798067373-0"
                     >
                       <span
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                       >
                         Last Result
                       </span>
                       <span
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                       >
                         <a
                           href={`/reports/casinoresults`}
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-0"
                         >
                           View All
                         </a>
                       </span>
                     </div>
                     {individualResult && (
                       <>
                         <div className="modal-backdrop fade show" />
                         <GenericIndividualResult
                           data={individualResult}
                           GAME_ID={GAME_ID}
                           shortName={shortName}
                           onClose={() => setIndividualResult(null)}
                         />
                       </>
                     )}
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="casino-last-results ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       {lastTenResultData?.data?.data?.casinoMarketHistoryResponseDTOS?.map(
                         (item) => (
                           <span
                             onClick={() => {
                              setIndividualResult(item?.marketId);
                              getIndividualResult(item?.marketId);
                              //  setIndividualResult("149250529165509")
                              //  getIndividualResult("149250529165509")
                               

                             }}
                             style={{
                               textAlign: "center",
                             }}
                             className={`ng-tns-c3502172659-5 result result-${
                               shortName == "bollywood"
                                 ? "b"
                                 : shortName == "aaa"
                                 ? item?.mainWinner.includes("A")
                                   ? "a"
                                   : item?.mainWinner.includes("B")
                                   ? "b"
                                   : "c"
                                 : shortName == "worli"
                                 ? "b"
                                 : shortName == "teenpattitest"
                                 ? item?.mainWinner.includes("T")
                                   ? "a"
                                   : item?.mainWinner.includes("L")
                                   ? "b"
                                   : "c"
                                 : shortName == "cards32a" ||
                                   shortName == "cards32a cards32b"
                                 ? item?.mainWinner.includes("8") ||
                                   item?.mainWinner.includes("9") ||
                                   item?.mainWinner.includes("10") ||
                                   item?.mainWinner.includes("11")
                                   ? "b"
                                   : "a"
                                 : shortName == "queen"
                                 ? item?.mainWinner.includes("0") ||
                                   item?.mainWinner.includes("1") ||
                                   item?.mainWinner.includes("2") ||
                                   item?.mainWinner.includes("3")
                                   ? "b"
                                   : "a"
                                 : shortName == "cmeter"
                                 ? item?.mainWinner.includes("H")
                                   ? "b"
                                   : "a"
                                 : shortName == "fiveCricket"
                                 ? item?.mainWinner.includes("A")
                                   ? "a"
                                   : item?.mainWinner.includes("T")
                                   ? "d"
                                   : "b"
                                 : shortName == "lucky7acards"
                                 ? item?.mainWinner.includes("H")
                                   ? "b"
                                   : item?.mainWinner.includes("T")
                                   ? "d"
                                   : "a"
                                 : item?.mainWinner.includes("T") ||
                                   item?.mainWinner.includes("R") ||
                                   item?.mainWinner.includes("B")
                                 ? "b"
                                 : "a"
                             } ng-star-inserted`}
                           >
                             <span className="ng-tns-c3502172659-5">
                               {" "}
                               {shortName === "race20" ? (
                                 <img
                                   src={`https://versionobj.ecoassetsservice.com/v24/static/front/img/icons/${
                                     item?.mainWinner == "D"
                                       ? "diamond"
                                       : item?.mainWinner == "H"
                                       ? "heart"
                                       : item?.mainWinner == "S"
                                       ? "spade"
                                       : "club"
                                   }.png`}
                                 />
                               ) : shortName == "cricket20" ? (
                                 <img
                                   src={`https://versionobj.ecoassetsservice.com/v24/static/front/img/balls/cricket20/ball${
                                     item?.mainWinner
                                   }.png`}
                                 />
                               ) : (
                                 item?.mainWinner
                               )}
                             </span>
                           </span>
                         )
                       )}
                     </div>
                   </div>
                 </div>
               </div>
             )}
             <div
               _ngcontent-ng-c1798067373=""
               className={`ng-tns-c1798067373-0 ${selectedTab == 0 &&
                 "d-none"} matchbettable w-100 ng-star-inserted`}
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="table-responsive ng-tns-c1798067373-0"
               >
                 <table
                   _ngcontent-ng-c1798067373=""
                   className="table ng-tns-c1798067373-0"
                 >
                   <thead
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0"
                   >
                     <tr
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-0"
                     >
                       <th
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                       >
                         Matched Bet
                       </th>
                       <th
                         _ngcontent-ng-c1798067373=""
                         className="text-end ng-tns-c1798067373-0"
                       >
                         Odds
                       </th>
                       <th
                         _ngcontent-ng-c1798067373=""
                         className="text-end ng-tns-c1798067373-0"
                       >
                         Stake
                       </th>
                     </tr>
                   </thead>
                   <tbody
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0"
                   >
                     {casinoBets?.data &&
                       casinoBets?.data?.response &&
                       casinoBets?.data?.code == 200 &&
                       casinoBets?.data?.response?.map((item) => (
                         <tr
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-0"
                         >
                           <td
                             _ngcontent-ng-c1798067373=""
                             className="ng-tns-c1798067373-0"
                           >
                             <span
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-0"
                             >
                               {item.runnerName}
                             </span>
                           </td>
                           <td
                             _ngcontent-ng-c1798067373=""
                             className="text-end ng-tns-c1798067373-0"
                           >
                             <span
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-0"
                             >
                               {item.back ? item.back : item.lay}
                             </span>
                           </td>
                           <td
                             _ngcontent-ng-c1798067373=""
                             className="text-end ng-tns-c1798067373-0"
                           >
                             <span
                               _ngcontent-ng-c1798067373=""
                               className="ng-tns-c1798067373-0"
                             >
                               {item.amount}
                             </span>
                           </td>
                         </tr>
                       ))}
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
         </div>
         <div
           _ngcontent-ng-c1798067373=""
           className="sidebar right-sidebar casino-right-sidebar ng-tns-c1798067373-0"
         >
           <div
             _ngcontent-ng-c1798067373=""
             className="sidebar-box place-bet-container d-xl-block d-none ng-tns-c1798067373-0"
           >
             <div
               _ngcontent-ng-c1798067373=""
               className="sidebar-title ng-tns-c1798067373-0"
             >
               <h4
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-0"
               >
                 Place Bet
               </h4>
             </div>
           </div>
           {selectedEventForBet && !isMobile && (
             <div>
               <div
                 _ngcontent-ng-c1798067373=""
                 className={`place-bet-box ng-tns-c1798067373-0  ng-star-inserted ${
                   selectedEventForBet?.type
                 }`}
               >
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="place-bet-box-header ng-tns-c1798067373-0"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-for ng-tns-c1798067373-0"
                   >
                     (Bet for)
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-odds ng-tns-c1798067373-0"
                   >
                     {" "}
                     odds{" "}
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-stake ng-tns-c1798067373-0"
                   >
                     Stake
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-profit ng-tns-c1798067373-0"
                   >
                     Profit
                   </div>
                 </div>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="place-bet-box-body ng-tns-c1798067373-0"
                 >
                   <a
                     _ngcontent-ng-c1798067373=""
                     onClick={() => {
                       dispatch({
                         type: "gameData/setSelectedEventForBet",
                         payload: null,
                       });
                     }}
                     className="text-danger placebet-close ng-tns-c1798067373-0"
                   >
                     <i
                       _ngcontent-ng-c1798067373=""
                       className="fa fa-times ng-tns-c1798067373-0"
                     />
                   </a>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-for ng-tns-c1798067373-0"
                   >
                     <span
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-0"
                     >
                       {selectedEventForBet?.runnerName}
                     </span>
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-odds ng-tns-c1798067373-0"
                   >
                     <input
                       _ngcontent-ng-c1798067373=""
                       type="text"
                       disabled={isLoading}
                       defaultValue=""
                       value={selectedEventForBet?.selectedOdd}
                       className="form-control ng-tns-c1798067373-0 ng-untouched ng-pristine"
                     />
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="spinner-buttons input-group-btn btn-group-vertical ng-tns-c1798067373-0"
                     >
                       <button
                         _ngcontent-ng-c1798067373=""
                         className="btn-default ng-tns-c1798067373-0"
                       >
                         <i
                           _ngcontent-ng-c1798067373=""
                           className="fa fa-angle-up ng-tns-c1798067373-0"
                         />
                       </button>
                       <button
                         _ngcontent-ng-c1798067373=""
                         className="btn-default ng-tns-c1798067373-0"
                       >
                         <i
                           _ngcontent-ng-c1798067373=""
                           className="fa fa-angle-down ng-tns-c1798067373-0"
                         />
                       </button>
                     </div>
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-stake ng-tns-c1798067373-0"
                   >
                     <input
                       onChange={(e) => {
                         handleAmountChange(e.target.value);
                       }}
                       value={selectedEventForBet?.amount}
                       _ngcontent-ng-c1798067373=""
                       type="number"
                       className="form-control ng-tns-c1798067373-0 ng-untouched ng-pristine ng-valid"
                     />
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="place-bet-profit ng-tns-c1798067373-0"
                   >
                     <span
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       {/* {
                      getProfit(
                        selectedEventForBet?.amount,
                        "casino",
                        selectedEventForBet
                      ).profit
                    } */}
                     </span>
                   </div>
                 </div>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="place-bet-buttons ng-tns-c1798067373-0"
                 >
                   {buttons?.sport?.map((item) => (
                     <button
                       disabled={isLoading}
                       onClick={() => {
                         handleAmountChange(item?.value);
                       }}
                       _ngcontent-ng-c1798067373=""
                       className="btn btn-place-bet ng-tns-c1798067373-0 ng-star-inserted"
                     >
                       {" "}
                       {item?.label}{" "}
                     </button>
                   ))}
                 </div>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="place-bet-action-buttons ng-tns-c1798067373-0"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0"
                   >
                     <button
                       onClick={() => {
                         dispatch({
                           type: "gameData/setSelectedEventForBet",
                           payload: null,
                         });
                       }}
                       disabled={isLoading}
                       _ngcontent-ng-c1798067373=""
                       className="btn btn-danger me-1 ng-tns-c1798067373-0"
                     >
                       {" "}
                       Reset{" "}
                     </button>
                   </div>
                   <div
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0"
                   >
                     <button
                       onClick={betPlace}
                       disabled={isLoading}
                       _ngcontent-ng-c1798067373=""
                       className="btn btn-success btn-loader ng-tns-c1798067373-0"
                     >
                       {isLoading ? (
                         <i
                           _ngcontent-ng-c1798067373=""
                           className="fa fa-spinner fa-spin "
                         />
                       ) : (
                         "Submit"
                       )}
                     </button>
                   </div>
                 </div>
               </div>
             </div>
           )}
           <div
             _ngcontent-ng-c1798067373=""
             className="sidebar-box my-bet-container d-xl-block d-none ng-tns-c1798067373-0"
           >
             <div
               _ngcontent-ng-c1798067373=""
               className="sidebar-title ng-tns-c1798067373-0"
             >
               <h4
                 _ngcontent-ng-c1798067373=""
                 className="ng-tns-c1798067373-0"
               >
                 My Bet
               </h4>
               <a
                 _ngcontent-ng-c1798067373=""
                 className="sideviewmore ng-tns-c1798067373-0"
               >
                 View more
               </a>
             </div>
             <div
               _ngcontent-ng-c1798067373=""
               className="my-bets ng-tns-c1798067373-0"
             >
               <div
                 _ngcontent-ng-c1798067373=""
                 className="table-responsive w-100 ng-tns-c1798067373-0"
               >
                 <table
                   _ngcontent-ng-c1798067373=""
                   className="table ng-tns-c1798067373-0"
                 >
                   <thead
                     _ngcontent-ng-c1798067373=""
                     className="ng-tns-c1798067373-0"
                   >
                     <tr
                       _ngcontent-ng-c1798067373=""
                       className="ng-tns-c1798067373-0"
                     >
                       <th
                         _ngcontent-ng-c1798067373=""
                         className="ng-tns-c1798067373-0"
                       >
                         Matched Bet 
                       </th>
                       <th
                         _ngcontent-ng-c1798067373=""
                         className="text-end ng-tns-c1798067373-0"
                       >
                         Odds
                       </th>
                       <th
                         _ngcontent-ng-c1798067373=""
                         className="text-end ng-tns-c1798067373-0"
                       >
                         Stake
                       </th>
                     </tr>
                   </thead>
                   <tbody>
                     {casinoBets?.data &&
                       casinoBets?.data?.response &&
                       casinoBets?.data?.code == 200 &&
                       casinoBets?.data?.response?.map((item) => (
                         <tr
                           className={`ng-tns-c3502172659-3 ${
                             item?.back ? "back" : "lay"
                           }`}
                         >
                           <td className="ng-tns-c3502172659-3">
                             {item?.runnerName}
                           </td>
                           <td className="text-end ng-tns-c3502172659-3">
                             {item?.back ? item?.back : item?.lay}
                           </td>
                           <td className="text-end ng-tns-c3502172659-3">
                             {item?.amount}
                           </td>
                         </tr>
                       ))}
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
           <div
             _ngcontent-ng-c1798067373=""
             className="sidebar-box sidebar-box-rules my-bet-container ng-tns-c1798067373-0"
           >
             {rule && ruleMap[rule]}
           </div>
         </div>
         {isMobile && (
           <div
             _ngcontent-ng-c1798067373=""
             id="placebetmodal"
             tabIndex={-1}
             aria-labelledby="placebetmodalLabel"
             className="modal fade ng-tns-c1798067373-0 show"
             aria-modal="true"
             role="dialog"
             style={{
               display: selectedEventForBet && "block",
             }}
           >
             <div
               _ngcontent-ng-c1798067373=""
               className="modal-dialog ng-tns-c1798067373-0"
             >
               <div
                 ref={modalRef}
                 _ngcontent-ng-c1798067373=""
                 className="modal-content ng-tns-c1798067373-0"
               >
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="modal-header  ng-tns-c1798067373-0"
                 >
                   <h5
                     _ngcontent-ng-c1798067373=""
                     id="placebetmodalLabel"
                     className="modal-title ng-tns-c1798067373-0"
                   >
                     Place Bet
                   </h5>
                   <button
                     _ngcontent-ng-c1798067373=""
                     type="button"
                     disabled={isLoading}
                     onClick={() => {
                       dispatch({
                         type: "gameData/setSelectedEventForBet",
                         payload: null,
                       });
                     }}
                     data-bs-dismiss="modal"
                     aria-label="Close"
                     className="btn-close ng-tns-c1798067373-0"
                   />
                 </div>
                 <div
                   _ngcontent-ng-c1798067373=""
                   className="modal-body ng-tns-c1798067373-0"
                 >
                   <div
                     _ngcontent-ng-c1798067373=""
                     className={`place-bet-modal ng-tns-c1798067373-0 ${
                       selectedEventForBet?.type
                     }`}
                   >
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-6 ng-tns-c1798067373-0"
                       >
                         <b
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-0"
                         >
                           {selectedEventForBet?.runnerName}
                         </b>
                       </div>
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-6 ng-tns-c1798067373-0"
                       >
                         <div
                           _ngcontent-ng-c1798067373=""
                           className="float-end ng-tns-c1798067373-0"
                         >
                           <button
                             _ngcontent-ng-c1798067373=""
                             className="stakeactionminus btn ng-tns-c1798067373-0"
                           >
                             <span
                               _ngcontent-ng-c1798067373=""
                               className="fa fa-minus ng-tns-c1798067373-0"
                             />
                           </button>
                           <input
                             _ngcontent-ng-c1798067373=""
                             type="text"
                             disabled={isLoading}
                             value={selectedEventForBet?.selectedOdd}
                             className="stakeinput ng-tns-c1798067373-0 ng-untouched ng-pristine"
                           />
                           <button
                             _ngcontent-ng-c1798067373=""
                             className="stakeactionminus btn ng-tns-c1798067373-0"
                           >
                             <span
                               _ngcontent-ng-c1798067373=""
                               className="fa fa-plus ng-tns-c1798067373-0"
                             />
                           </button>
                         </div>
                       </div>
                     </div>
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="row mt-2 ng-tns-c1798067373-0"
                     >
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-4 ng-tns-c1798067373-0"
                       >
                         <input
                           _ngcontent-ng-c1798067373=""
                           type="number"
                           disabled={isLoading}
                           onChange={(e) => {
                             handleAmountChange(e.target.value);
                           }}
                           value={selectedEventForBet?.amount}
                           className="stakeinput w-100 ng-tns-c1798067373-0 ng-untouched ng-pristine ng-valid"
                         />
                       </div>
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-4 d-grid ps-0 ng-tns-c1798067373-0"
                       >
                         <button
                           disabled={isLoading}
                           onClick={betPlace}
                           _ngcontent-ng-c1798067373=""
                           className="btn btn-primary btn-block btn-loader ng-tns-c1798067373-0"
                         >
                           {isLoading ? (
                             <i
                               _ngcontent-ng-c1798067373=""
                               className="fa fa-spinner fa-spin "
                             />
                           ) : (
                             "Submit"
                           )}
                         </button>
                       </div>
                       <div
                         _ngcontent-ng-c1798067373=""
                         className="col-4 text-center pt-2 ng-tns-c1798067373-0"
                       >
                         <span
                           _ngcontent-ng-c1798067373=""
                           className="ng-tns-c1798067373-0 ng-star-inserted"
                         >
                           {/* {selectedEventForBet &&
                          getProfit(
                            selectedEventForBet?.amount,
                            "casino",
                            selectedEventForBet
                          )?.profit} */}
                         </span>
                       </div>
                     </div>
                     <div
                       _ngcontent-ng-c1798067373=""
                       className="place-bet-buttons mt-2 ng-tns-c1798067373-0"
                     >
                       {buttons?.sport?.map((item) => (
                         <button
                           disabled={isLoading}
                           _ngcontent-ng-c1798067373=""
                           onClick={() => {
                             handleAmountChange(item?.value);
                           }}
                           className="btn btn-place-bet ng-tns-c1798067373-0 ng-star-inserted"
                         >
                           {" "}
                           {item?.label}{" "}
                         </button>
                       ))}
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         )}
         {showRules && ruleMap[shortName] && (
           <>
             <div class="fade modal-backdrop show" />
             <div
               role="dialog"
               aria-modal="true"
               className="fade modal show"
               tabIndex={-1}
               style={{ display: "block" }}
             >
               <div className="modal-dialog modal-lg">
                 <div className="modal-content">
                   <div className="modal-header">
                     <div className="modal-title h4">{gameName} Rules</div>
                     <button
                       onClick={() => {
                         setShowRules(false);
                       }}
                       type="button"
                       className="btn-close"
                       aria-label="Close"
                     />
                   </div>
                   <div className="modal-body">
                     <div>
                       <style
                         type="text/css"
                         dangerouslySetInnerHTML={{
                           __html:
                             '\n        .rules-section .row.row5 {\n            margin-left: -5px;\n            margin-right: -5px;\n        }\n        .rules-section .pl-2 {\n            padding-left: .5rem !important;\n        }\n        .rules-section .pr-2 {\n            padding-right: .5rem !important;\n        }\n        .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] {\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n        .rules-section\n        {\n            text-align: left;\n            margin-bottom: 10px;\n        }\n        .rules-section .table\n        {\n            color: #fff;\n            border:1px solid #444;\n            background-color: #222;\n            font-size: 12px;\n        }\n        .rules-section .table td, .rules-section .table th\n        {\n            border-bottom: 1px solid #444;\n        }\n        .rules-section ul li, .rules-section p\n        {\n            margin-bottom: 5px;\n        }\n        .rules-section::-webkit-scrollbar {\n            width: 8px;\n        }\n        .rules-section::-webkit-scrollbar-track {\n            background: #666666;\n        }\n\n        .rules-section::-webkit-scrollbar-thumb {\n            background-color: #333333;\n        }\n        .rules-section .rules-highlight\n        {\n            color: #FDCF13;\n            font-size: 16px;\n        }\n        .rules-section .rules-sub-highlight {\n            color: #FDCF13;\n            font-size: 14px;\n        }\n        .rules-section .list-style, .rules-section .list-style li\n        {\n            list-style: disc;\n        }\n        .rules-section .rule-card\n        {\n            height: 20px;\n            margin-left: 5px;\n        }\n        .rules-section .card-character\n        {\n            font-family: Card Characters;\n        }\n        .rules-section .red-card\n        {\n            color: red;\n        }\n        .rules-section .black-card\n        {\n            color: black;\n        }\n        .rules-section .cards-box\n        {\n            background: #fff;\n            padding: 6px;\n            display: inline-block;\n            color: #000;\n            min-width: 150px;\n        }\n    ',
                         }}
                       />
                       <div className="rules-section">
                         <div>
                           {typeof ruleMap[shortName] == "string" ? (
                             <img
                               src={ruleMap[shortName]}
                               className="img-fluid"
                             />
                           ) : (
                             ruleMap[shortName]
                           )}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </>
         )}
       </div>
     );
   }
